import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { getTranslations } from '@translations';
import { Button, Icon } from '@components';

import styles from './styles/index.module.scss';

const List = ({ className }) => {
  const translations = getTranslations();
  return (
    <div className={cn(styles.list, className)}>
      <Button
        color="transparent"
        className={styles.listTab}
        tag="a"
        href={translations('header.menu.lists.url')}
      >
        <Icon size="24" id="list" className={styles.listIcon} />
        <span className={styles.listText}>
          {translations('header.menu.lists')}
        </span>
      </Button>
    </div>
  );
};

List.propTypes = {
  className: PropTypes.string,
};

List.defaultProps = {
  className: null,
};

List.displayName = 'List';

export default List;
